import { render } from "./TripDetails.vue?vue&type=template&id=482a5fbb&scoped=true&ts=true"
import script from "./TripDetails.vue?vue&type=script&lang=ts"
export * from "./TripDetails.vue?vue&type=script&lang=ts"

import "./TripDetails.vue?vue&type=style&index=0&id=482a5fbb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Desktop\\Cursos\\11 Vue\\10-maps-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482a5fbb"]])

export default __exports__